import { render, staticRenderFns } from "./MaterialDevDashboard.vue?vue&type=template&id=74418377&"
import script from "./MaterialDevDashboard.vue?vue&type=script&lang=js&"
export * from "./MaterialDevDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports